export default __webpack_public_path__ + "static/media/slider_1-md@2x.d451c546.jpg";